var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPublish = function SvgPublish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.915 3.753c.78.78.78 2.048 0 2.83-.781.78-2.048.78-2.83 0a2 2 0 1 1 2.83-2.83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M.5 5.167c0-.44.101-.874.297-1.275v0C1.807 1.827 4.04.5 6.5.5c2.46 0 4.693 1.327 5.703 3.392v0c.196.4.297.835.297 1.275 0 .439-.101.874-.297 1.274v0C11.193 8.506 8.96 9.833 6.5 9.833c-2.46 0-4.693-1.327-5.703-3.392v0A2.898 2.898 0 0 1 .5 5.167",
    clipRule: "evenodd"
  })));
};
export { SvgPublish as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMTkyYWIyY2Q2NDFmZDkyYzAzNTZlM2NmN2IzZTI5NzAuc3ZnIjs=";